import { render, staticRenderFns } from "./zen_slim.vue?vue&type=template&id=913b237e&scoped=true&"
import script from "./zen_slim.vue?vue&type=script&lang=js&"
export * from "./zen_slim.vue?vue&type=script&lang=js&"
import style0 from "./zen_slim.vue?vue&type=style&index=0&id=913b237e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913b237e",
  null
  
)

export default component.exports